import React, { FC } from 'react';
import { useScreensConfig } from '../config/screens.context';
import SpeakerModal from './SpeakerModal';
import { Screen } from '../types';
import WorkshopModal from '../workshops/components/WorkshopModal';
import UserProfileNetworkingModal from '../profile/components/UserProfileNetworkingBlock/UserProfileNetworkingModal';

export type ModalUrlProps = {
  modal?: string;
  collection?: string;
  speakerId?: string;
  userId?: string;
  workshopId?: string;
};

type ModalRouterProps = ModalUrlProps & {
  onClose: (state: any) => void;
};

const modalComponents: Record<string, FC> = {
  'modal-speaker': SpeakerModal,
  'modal-workshop': WorkshopModal,
  'modal-user-profile-networking': UserProfileNetworkingModal,
};

const ModalRouter: FC<ModalRouterProps> = ({ modal, ...id }) => {
  const screens = useScreensConfig() as Record<string, Screen>;

  const modalConfig = Object.values(screens).find(({ pageType, modalKey }) => {
    return pageType === 'modal' && modalKey === modal;
  });

  if (!modalConfig) {
    return null;
  }

  const { type } = modalConfig;

  const Component = modalComponents[type];
  if (!Component) return null;

  return (
    <Component
      key={id.userId || id.workshopId || id.speakerId || id.collection}
      {...id}
      {...modalConfig}
    />
  );
};

export default ModalRouter;
